import { render, staticRenderFns } from "./NewClient.vue?vue&type=template&id=1e44c924&scoped=true"
import script from "./NewClient.vue?vue&type=script&lang=js"
export * from "./NewClient.vue?vue&type=script&lang=js"
import style0 from "./NewClient.vue?vue&type=style&index=0&id=1e44c924&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e44c924",
  null
  
)

export default component.exports